import React from 'react';
import classNames from 'classnames';

import Warning from '@ast/magma/components/icon/icons/Warning';
import { Dialog } from '@ast/magma/components/dialog';
import { UserError } from '@app/common/errors/UserError';
import { DialogProps } from '@ast/magma/components/dialog/dialog';
import { useBreakpoint } from '@ast/magma/breakpoints';

import styles from './ErrorDialog.pcss';

/**
 * Error dialog properties.
 */
export interface ErrorDialogProps {
  /**
   * User facing error.
   */
  readonly error:UserError;
  /**
   * Cutom error dialog footer component.
   */
  readonly footer: React.ReactNode;
}

export type ErrorDialogPropsBase = Omit<DialogProps, 'status' | 'align' | 'predefinedWidth' | 'title'>;

/**
 * Error dialog component to show user facing error.
 * @param props
 */
export const ErrorDialog = (props: ErrorDialogProps & ErrorDialogPropsBase) => {
  const {
    error,
    className,
    children,
    footer,
    ...otherDialogProps
  } = props;

  const isMobile = useBreakpoint().device === 'mobile';

  return (
    <Dialog
      // eslint-disable-next-line i18next/no-literal-string
      predefinedWidth="md"
      align={isMobile ? 'bottom' : 'center'}
      status={{
        icon: <Warning />,
        level: 'info',
      }}
      fixedTitle={false}
      title={error.title}
      className={classNames(styles.dialog, className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...otherDialogProps}
    >
      <div className={styles.message}>{error.message}</div>
      {children}
      { footer }
    </Dialog>
  );
};
